import React, { useEffect, useRef, useState } from "react";
import Navbar from "../NavBar";
import NewSidebar from "../newSideBar";
import { Link } from "react-router-dom";
import InboxPanel from "../Inbox/InboxPanel";
import axios from "axios";
import { Spinner } from "react-bootstrap"; // Import Bootstrap spinner
import "./ticket.css";

const Tickets = () => {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [replyMessage, setReplyMessage] = useState(""); // Input for admin reply
  const localURL = localStorage.getItem("shopURL");
  const [loading, setLoading] = useState(false); // Loading state
  const [chatLoading, setChatLoading] = useState(true); // State for loading

  const chatContainerRef = useRef(null);
  const chatEndRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);

  const headers = {
    "Content-Type": "application/json",
    "x-shop-url": localURL,
  };

  const handleScroll = () => {
    if (chatContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        chatContainerRef.current;
      // Check if the user is at the bottom
      setIsAtBottom(scrollTop + clientHeight >= scrollHeight - 10);
    }
  };
  useEffect(() => {
    // Scroll to the bottom of the chat-box when new messages are added
    if (isAtBottom && chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [isAtBottom]);

  useEffect(() => {
    // Reset scroll to bottom when a new chat (collection) is opened
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
    setIsAtBottom(true); // Assume starting at the bottom for a new chat
  }, [selectedTicket]); // Trigger only when the chat collection changes

  const formatDateOnly = (timestamp) => {
    const date = new Date(timestamp);
    const dateString = date
      .toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .replace(",", ""); // Removing unwanted comma

    const [datePart] = dateString.split(" "); // Extract date part
    const [day, month, year] = datePart.split("/").map(Number); // Parse day, month, year

    // Return formatted date (e.g., 14-11-2024)
    return `${day.toString().padStart(2, "0")}-${month
      .toString()
      .padStart(2, "0")}-${year}`;
  };

  function formatTimeOnly(isoString) {
    const date = new Date(isoString);
    return date.toLocaleTimeString([], { // Empty array = use browser's locale
      hour: '2-digit',
      minute: '2-digit',
      hour12: true // Forces 12-hour format (AM/PM)
    });
  }


  const fetchTickets = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/admin/tickets`,
        { headers }
      );
      setTickets(res.data); // Store tickets
    } catch (error) {
      console.error("Error fetching tickets:", error);
    } finally {
      setChatLoading(false); // Stop loading after data fetch
    }
  };

  // Fetch tickets from API
  useEffect(() => {
    fetchTickets();
  }, []);

  // Handle selecting a ticket
  const handleTicketSelect = (ticket) => {
    setSelectedTicket(ticket);
  };

  // Handle sending a reply
  const sendReply = async () => {
    if (!replyMessage.trim() || !selectedTicket) return;
    setLoading(true); // Start loading

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/admin/tickets/${selectedTicket._id}/reply`,
        { sender: "Admin", message: replyMessage }, // Add sender field
        { headers }
      );

      if (res.status === 200) {
        // Only proceed if the response is successful
        // Update replies in selected ticket
        setSelectedTicket((prevTicket) => ({
          ...prevTicket,
          replies: [...prevTicket.replies, res.data],
        }));

        setReplyMessage(""); // Clear input field
        fetchTickets(); // Fetch tickets only if response is OK
      }
    } catch (error) {
      console.error("Error sending reply:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="d-flex flex-column w-100">
      <Navbar />
      <div className="d-flex">
        <NewSidebar />
        <div
          className="main-panel"
          style={{ overflowY: "auto", maxHeight: "calc(100vh - 64px)" }}
        >
          {" "}
          {chatLoading ? (
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#f0f1f6",
              }}
            >
              <Spinner
                animation="border"
                variant="primary"
                style={{ width: "3rem", height: "3rem" }}
              />
            </div>
          ) : (
            <div className="content-wrapper">
              <div className="d-flex justify-content-between">
                <h2 className="text-dark font-weight-bold mb-0">Tickets</h2>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="tab-content tab-transparent-content">
                    <div className="tab-pane fade show active">
                      <div className="row">
                        <div className="col-12 grid-margin">
                          <div className="card">
                            <div className="card-body">
                              <div className="row d-flex flex-wrap">
                                <InboxPanel />

                                {/* Ticket List */}
                                {/* Tickets List Panel */}
                                <div className="tickets-list-panel col-md-3">
                                  <div className="panel-header">
                                    <h3 className="panel-title">All Tickets</h3>
                                    <div className="panel-badge">
                                      {tickets.length}
                                    </div>
                                  </div>
                                  <div className="tickets-list">
                                    {tickets.length === 0 ? (
                                      <div className="empty-state">
                                        <i className="mdi mdi-ticket-confirmation-outline"></i>
                                        <p>No tickets found</p>
                                      </div>
                                    ) : (
                                      tickets.map((ticket) => (
                                        <div
                                          key={ticket._id}
                                          className={`ticket-item ${
                                            selectedTicket?._id === ticket._id
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={() =>
                                            handleTicketSelect(ticket)
                                          }
                                        >
                                          <div className="ticket-avatar">
                                            {ticket.subject
                                              .charAt(0)
                                              .toUpperCase()}
                                          </div>
                                          <div className="ticket-info">
                                            <div className="ticket-subject">
                                              {ticket.subject}
                                            </div>
                                            <div className="ticket-meta">
                                              <span className="ticket-email">
                                                {ticket.email}
                                              </span>
                                              <span className="ticket-date">
                                                {formatDateOnly(
                                                  ticket.createdAt
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    )}
                                  </div>
                                </div>

                                {/* Ticket Conversation Panel */}
                <div className="ticket-conversation-panel col-md-4">
                  <div className="panel-header">
                    <h3 className="panel-title">
                      {selectedTicket ? selectedTicket.subject : "Select a Ticket"}
                    </h3>
                  </div>
                  
                  <div className="ticket-messages-container" ref={chatContainerRef} onScroll={handleScroll}>
                    {selectedTicket ? (
                      selectedTicket.replies.length > 0 ? (
                        selectedTicket.replies.map((reply, index) => {
                          const isDateChanged = 
                            index === 0 ||
                            formatDateOnly(reply.timestamp) !== 
                            formatDateOnly(selectedTicket.replies[index - 1]?.timestamp);

                          return (
                            <React.Fragment key={index}>
                              {isDateChanged && (
                                <div className="ticket-date-divider">
                                  <span>{formatDateOnly(reply.timestamp)}</span>
                                </div>
                              )}
                              
                              <div className={`ticket-message ${reply.sender === "Admin" ? 'admin' : 'user'}`}>
                                <div className="message-content">
                                  <p>{reply.message}</p>
                                  <div className="message-meta">
                                    <span className="message-time">
                                      {formatTimeOnly(reply.timestamp)}
                                    </span>
                                    <span className="message-sender">
                                      {reply.sender}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <div className="empty-conversation">
                          <i className="mdi mdi-message-text-outline"></i>
                          <p>No reply from Client in this ticket</p>
                        </div>
                      )
                    ) : (
                      <div className="empty-conversation">
                        <i className="mdi mdi-ticket-confirmation-outline"></i>
                        <p>Select a ticket to view conversation</p>
                      </div>
                    )}
                    <div ref={chatEndRef} />
                  </div>

                  {selectedTicket && (
                    <div className="ticket-reply-container">
                      <textarea
                        className="ticket-reply-input"
                        placeholder="Type your reply..."
                        rows="3"
                        value={replyMessage}
                        onChange={(e) => setReplyMessage(e.target.value)}
                      />
                      <button
                        className="ticket-reply-button"
                        onClick={sendReply}
                        disabled={loading || !replyMessage.trim()}
                      >
                        {loading ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          <>
                            <i className="mdi mdi-send"></i> Send Reply
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>

                                {/* Ticket Details Panel */}
                <div className="ticket-details-panel col-md-3">
                  <div className="panel-header">
                    <h3 className="panel-title">Ticket Details</h3>
                  </div>
                  {selectedTicket ? (
                    <div className="ticket-details-content">
                      <div className="detail-item">
                        <i className="mdi mdi-email detail-icon"></i>
                        <div>
                          <div className="detail-label">Customer Email</div>
                          <div className="detail-value">{selectedTicket.email}</div>
                        </div>
                      </div>
                      <div className="detail-item">
                        <i className="mdi mdi-calendar detail-icon"></i>
                        <div>
                          <div className="detail-label">Created</div>
                          <div className="detail-value">
                            {formatDateOnly(selectedTicket.createdAt)} at {formatTimeOnly(selectedTicket.createdAt)}
                          </div>
                        </div>
                      </div>
                      <div className="detail-item">
                        <i className="mdi mdi-message-text detail-icon"></i>
                        <div>
                          <div className="detail-label">First Mail  Message</div>
                          <div className="detail-value">{selectedTicket.message}</div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="empty-details">
                      <i className="mdi mdi-information-outline"></i>
                      <p>Select a ticket to view details</p>
                    </div>
                  )}
                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Tickets;
